exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".feature-unavailable {\n  font-weight: bold;\n  color: red;\n}", ""]);
